export const TRANSFER_DETAILS_SECTION_ID = 'transfer-details'

type OfferWithOptionalTransferDetails = {
  transferDetails?: App.OfferTransferDetails | null
}

export function getAuthoredTransferDetails(
  offer?: App.AnyOffer | OfferWithOptionalTransferDetails | null,
): App.OfferTransferDetails | undefined {
  if (!offer || !('transferDetails' in offer)) return undefined

  const heading = offer.transferDetails?.heading?.trim() ?? ''
  const body = offer.transferDetails?.body?.trim() ?? ''

  if (!heading && !body) return undefined

  return { heading, body }
}
